import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogData } from '../../models/confirm-dialog-data.model';

@Component({
    selector: 'mat-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: [ './confirm-dialog.component.scss' ],
})
export class ConfirmDialogComponent {

    public caption: string;
    public message: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public messageParams: any;
    public acceptLabel: string;
    public rejectLabel: string;
    public showReject: boolean;
    public touch: boolean;

    constructor(@Inject(MAT_DIALOG_DATA) private data: ConfirmDialogData) {
        this.caption = data.caption != null ? data.caption : 'sla.ui-material.message.confirmation.label';
        this.message = data.message != null ? data.message : 'sla-ui.commons.confirm-process.message';
        this.acceptLabel = data.acceptLabel != null ? data.acceptLabel : 'sla.ui-material.button.confirm.label';
        this.rejectLabel = data.rejectLabel != null ? data.rejectLabel : 'sla.ui-material.button.cancel.label';
        this.showReject = data.showReject != null ? data.showReject : true;
        this.touch = data.touch != null ? data.touch : false;
        this.messageParams = data.messageParams;
    }
}
